<template>
  <div class="news-wrapper main flex-between">
        <div class="left-section">
            <div class="subtitle headlines-subtitle">
                <h2>头条新闻</h2>
            </div>
            <ul class="news-lists">
                <li class="flex-align-between" v-for="(li, index) in lists" :key="index" @click="toDetail(li.id)">
                    <img :src="li.cover" alt="">
                    <div class="article">
                        <h3 class="f16 wes">{{li.title}}</h3>
                        <p class="f12 wes-2">{{li.introduction}}</p>
                        <div class="summary flex-align-between">
                            <span class="date">{{li.updateTime}}</span>
                            <span class="look-num">{{li.views || 0}}</span>
                        </div>
                    </div>
                </li>
            </ul>
           
        <div class="loading">
            <button class="load-more" @click="getNewsList()" :class="[loadClass?'load-more':'load-more-none']">{{loadText}}</button>                  
        </div>
        </div>
        <focusBar></focusBar>
    </div>    
</template>

<script>
export default {
    data() {
        return {
            currentPage:1,
            loadText:'加载更多',
            loadClass:true,
            lists:[],
        }
    },
    methods: {
        async getNewsList(){
            let that = this;
            let params = {
                clazz:1,
                isAsc:'desc',
                pageNum: this.currentPage++,
                pageSize: 7
            }            

            let resData = await Api.News.GetNewsList(params)
            // console.log(resData)

            params.pageNum = this.currentPage;
            let res = await Api.News.GetNewsList(params)
            if(res.rows.length < 1) {
                this.loadText = '加载已完成'
                this.loadClass = false;
            }
            
            that.lists = this.lists.concat(resData.rows);


            // that.clickGetList();
         },

         toDetail(id) {
             console.log(id);
             Common.goPage(`/news/headlines/detail/${id}`,this)
         }
    },
    mounted(){
        this.$nextTick(function(){
            this.getNewsList();
        })
        
    }
}
</script>

<style lang="less">
     @import "../less/news_common.less";
     @import "../less/news_headlines.less";
</style>